enum DeploymentTypes {
  SET_ALL_TENANTS = '[TENANT] SET_ALL',
  SELECT_TENANT = '[TENANT] SELECT',
}

export default DeploymentTypes;
